export default function getColumns() {
	return [
		{
			Header: 'Name',
			accessor: 'name',
			id: 'name',
			filterPath: ':name',
		},
		{
			Header: 'Description',
			accessor: 'description',
			id: 'description',
			filterPath: ':description',
		},
	];
}
